// The page's filter strip (AppFilterBar): the first ancestor of its "Filters" label that holds the fields
function findFilterBar() {
	let el = [...document.querySelectorAll('p.MuiTypography-root, span.MuiTypography-root')].find(e => e.textContent.trim() === 'Filters')
	while (el && !el.querySelector('input')) el = el.parentElement
	return el
}

// The card of the daily searches chart (real chart or demo), by its title
function findChartCard() {
	const el = [...document.querySelectorAll('.MuiTypography-root')].find(e => e.textContent.trim() === 'Daily searches vs Previous Month')
	return el?.closest('.MuiPaper-root') || null
}

// The engine measures the target 250 ms after a smooth scroll starts, too early for a long scroll (a block
// at the bottom of the page): this target jumps there at once, so the spotlight lands on it.
function instant(el) {
	return el && {
		scrollIntoView: () => el.scrollIntoView({ block: 'center' }),
		getBoundingClientRect: () => el.getBoundingClientRect(),
	}
}

const byTourId = id => instant(document.querySelector(`[data-tour-id="${id}"]`))

const ES = navigator.language?.startsWith('es')

export const TOUR_STEPS = [
	{
		type: 'intro',
		icon: 'chart-mixed',
		title: ES ? 'Bienvenido a Analíticas de Búsqueda' : 'Welcome to Search Analytics',
		description: ES
			? 'Este panel muestra cómo se está utilizando el motor de búsqueda personalizado de Europcar. Consulta los volúmenes de búsqueda, observa las tendencias diarias comparadas con el mes anterior y desglosa la actividad por empresa, usuario y sitio.'
			: 'This dashboard shows how Europcar\'s custom search engine is being used. Track search volumes, see daily trends compared to the previous month, and break down activity by company, user, and site.',
	},
	{
		type: 'field',
		findTarget: () => instant(findFilterBar()),
		icon: 'filter',
		title: ES ? 'Filtros' : 'Filters',
		description: ES
			? 'Filtra el panel por rango de fechas, empresa, usuario y sitio. Los datos se actualizan automáticamente al cambiar cualquier filtro, sin necesidad de pulsar un botón de búsqueda. El rango de fechas predeterminado es los últimos 7 días.'
			: 'Filter the dashboard by date range, company, user, and site. Data updates automatically when you change any filter — no search button needed. The date range defaults to the last 7 days.',
		example: '"Date Range" | "Companies" | "Users" | "Sites"',
	},
	{
		type: 'field',
		findTarget: () => byTourId('analytics-kpi-cards'),
		icon: 'chart-simple',
		title: ES ? 'Tarjetas de Volumen de Búsqueda' : 'Search Volume Cards',
		description: ES
			? 'Tres tarjetas KPI que muestran el total de búsquedas: para el rango de fechas seleccionado, la semana actual y el mes actual. Los números se animan con un efecto de conteo cuando se cargan los datos.'
			: 'Three KPI cards showing total search counts: for the selected date range, the current week, and the current month. Numbers animate with a count-up effect when data loads.',
		example: ES ? '«Date Range»: 1.380 | «This week»: 312 | «This month»: 1.890' : '"Date Range": 1,380 | "This week": 312 | "This month": 1,890',
	},
	{
		type: 'field',
		findTarget: () => instant(findChartCard()),
		icon: 'chart-column',
		title: ES ? 'Gráfico de Búsquedas Diarias' : 'Daily Searches Chart',
		description: ES
			? 'Gráfico de columnas que compara los volúmenes de búsqueda diarios con el mismo periodo del mes anterior. Dos series codificadas por color permiten detectar tendencias: ¿las búsquedas crecen, disminuyen o son estacionales? Pasa el ratón sobre cualquier barra para ver los conteos exactos.'
			: 'Column chart comparing daily search volumes against the same period last month. Two color-coded series let you spot trends — are searches growing, declining, or seasonal? Hover any bar for exact counts.',
		example: ES ? 'Azul = «Searches» | Cian claro = «Searches Previous Month»' : 'Blue = "Searches" | Light cyan = "Searches Previous Month"',
	},
	{
		type: 'field',
		findTarget: () => byTourId('analytics-searches-by-company'),
		icon: 'building',
		title: ES ? 'Búsquedas por Empresa' : 'Searches by Company',
		description: ES
			? 'Un gráfico circular que muestra la distribución de búsquedas por empresa/país, junto con una tabla detallada debajo. Consulta de un vistazo qué mercados generan más volumen de búsqueda.'
			: 'A pie chart showing the distribution of searches across companies/countries, plus a detailed table below. See which markets are driving the most search volume at a glance.',
	},
	{
		type: 'field',
		findTarget: () => byTourId('analytics-searches-by-user'),
		icon: 'user',
		title: ES ? 'Búsquedas por Usuario' : 'Searches by User',
		description: ES
			? 'Muestra qué usuarios individuales realizan más búsquedas. El gráfico circular ofrece una visión rápida y la tabla lista cada usuario con su número exacto de búsquedas.'
			: 'Shows which individual users are performing the most searches. The pie chart gives a quick overview, and the table lists each user with their exact search count.',
	},
	{
		type: 'field',
		findTarget: () => byTourId('analytics-searches-by-site'),
		icon: 'globe-pointer',
		title: ES ? 'Búsquedas por Sitio' : 'Searches by Site',
		description: ES
			? 'Desglosa la actividad de búsqueda por sitio web de alquiler. Permite entender qué sitios de la competencia se monitorizan con más frecuencia. Cada bloque incluye un gráfico circular para proporciones y una tabla con los números exactos.'
			: 'Breaks down search activity by rental website. Understand which competitor sites are being monitored most frequently. Each block includes a pie chart for proportions and a table for exact numbers.',
	},
	{
		type: 'outro',
		icon: 'star',
		title: ES ? '¡Todo Listo!' : "You're All Set!",
		description: ES
			? 'Ajusta el rango de fechas y los filtros para explorar diferentes periodos. Todos los gráficos y tablas se actualizan automáticamente. Usa los desgloses por empresa, usuario y sitio para entender los patrones de búsqueda en tu organización.'
			: 'Adjust the date range and filters to explore different time periods. All charts and tables update automatically. Use the company, user, and site breakdowns to understand search patterns across your organization.',
	},
]
